interface IParams {
  key?: string;
  group?: string;
  context: {
    cache: any;
  };
}

/**
 * Delete value from cache
 *
 * @param {string} group if present, group where to get the value from
 * @param {string} key key where to get the value from
 *
 * @returns
 */
function deleteCache({ key, group, context }: IParams) {
  const { cache } = context;

  if (!key && group) {
    // If only the group is provided we're going to delete the whole group
    delete cache[group];
    return;
  } else if (key) {
    // If the key is provided we're going to delete the key from the group or the root of the cache object
    if (!group) {
      delete cache[key];
    } else {
      if (!cache[group]) {
        return;
      }
      delete cache[group][key];
    }
  }

  return;
}

export default deleteCache;
